import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import ServiceActionPerformersField from './ServiceActionPerformers';

interface BatteryReplacementFormDialogProps {
    visible: boolean;
    mobileView: boolean;
    title: string;
    value: any;
    onChange: (patch: any) => void;
    onHide: () => void;
    onSave: () => void;
    systemNames?: string[];
    fixedSystemName?: string;
    fixedDate?: string;
}
const reasonOptions = [
    { label: 'Planned', value: true },
    { label: 'Malfunctioned', value: false },
];

const BatteryReplacementFormDialog = ({
    visible,
    mobileView,
    title,
    value,
    onChange,
    onHide,
    onSave,
    systemNames,
    fixedSystemName,
    fixedDate,
}: BatteryReplacementFormDialogProps) => {
    function formatDateRemoveTime(date) {
        return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0") + "-" + String(date.getDate()).padStart(2, "0");
    }

    const onInputChange = (e, name) => {
        let val = e.value !== undefined ? e.value : e.target?.value ?? null;
        if (name === 'date') {
            val = formatDateRemoveTime(val);
        }
        onChange({ [name]: val });
    };

    const footer = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={onHide} />
            <Button label="Save" icon="pi pi-check" onClick={onSave} />
        </React.Fragment>
    );

    return (
        <Dialog visible={visible}
                style={{ width: mobileView ? '100%' : '30rem' }}
                breakpoints={{ '641px': '90vw' }}
                modal className="p-fluid" footer={footer} onHide={onHide}
                header={title}
                >
            <div className="formgrid grid">
                <div className="field col">
                    <label className="mb-3 font-bold">System</label>
                    {systemNames ? (
                        <Dropdown value={value.systemName} onChange={(e) => onInputChange(e, 'systemName')} options={systemNames}
                            filter placeholder="Select system" className="w-full" invalid={!value.systemName} />
                    ) : (
                        <Dropdown value={fixedSystemName ?? value.systemName ?? ''} options={[fixedSystemName ?? value.systemName ?? '']}
                            disabled className="w-full" />
                    )}
                </div>
                <div className="field col">
                    <label className="mb-3 font-bold">Date</label>
                    {fixedDate ? (
                        <Calendar value={new Date(fixedDate)} disabled dateFormat="yy-mm-dd" />
                    ) : (
                        <Calendar value={new Date(value.date)} onChange={(e) => onInputChange(e, 'date')} dateFormat="yy-mm-dd" invalid={!value.date} />
                    )}
                </div>
            </div>
            <div className="field">
                <label className="mb-3 font-bold">Reason</label>
                <Dropdown
                    value={value.batteryReplacementPlanned}
                    options={reasonOptions}
                    onChange={(e) => onChange({ batteryReplacementPlanned: e.value })}
                />
            </div>
            <div className="field">
                <label className="mb-3 font-bold">Performed by</label>
                <ServiceActionPerformersField value={value} onChange={onChange} />
            </div>
        </Dialog>
    );
};

export default BatteryReplacementFormDialog;
